import { apiFetch } from './client';

export type TemplateType = 'invite' | 'password_reset' | 'welcome' | 'notification';

export interface EmailTemplateRow {
  type: TemplateType;
  subject: string | null;
  html_body: string | null;
  is_override: boolean;
  scope: 'reseller' | 'customer';
}

export interface EmailTemplateListResponse {
  templates: EmailTemplateRow[];
}

export interface EmailTemplateDefault {
  type: TemplateType;
  subject: string | null;
  html_body: string | null;
  has_default: boolean;
}

export const emailTemplates = {
  list: () => apiFetch<EmailTemplateListResponse>('/api/email-templates'),

  get: (type: TemplateType) =>
    apiFetch<EmailTemplateRow>(`/api/email-templates/${type}`),

  /**
   * Fetch the built-in default template (raw HTML + subject, no variable
   * substitution). Used by the portal to show "this is what we'd send if
   * you don't override" alongside the editor. Returns has_default=false
   * for templates with no on-disk default (e.g. notification).
   */
  getDefault: (type: TemplateType) =>
    apiFetch<EmailTemplateDefault>(`/api/email-templates/${type}/default`),

  save: (type: TemplateType, body: { subject: string; html_body: string }) =>
    apiFetch<{ ok: true }>(`/api/email-templates/${type}`, {
      method: 'PUT',
      body: JSON.stringify(body),
    }),

  remove: (type: TemplateType) =>
    apiFetch<{ ok: true }>(`/api/email-templates/${type}`, { method: 'DELETE' }),
};
